// Rewrite to class
export default function initTabs() {
    window.addEventListener('DOMContentLoaded', () => {
        const tabHolders = document.querySelectorAll('[data-tabs]');

        tabHolders.forEach((tabHolder) => {
            const tabLinks = tabHolder.querySelectorAll('[data-show-tab]');
            const tabContents = tabHolder.querySelectorAll('[data-content-tab]');

            function unselectLinks() {
                tabLinks.forEach((tabLink) => {
                    tabLink.setAttribute('aria-selected', 'false');
                });
            }

            function selectLink(link) {
                link.setAttribute('aria-selected', 'true');
            }

            function hideTabs() {
                tabContents.forEach((tabContent) => {
                    tabContent.setAttribute('aria-hidden', 'true');
                    tabContent.classList.add('hidden');
                });
            }

            function showTab(tab, focus = false) {
                tab.setAttribute('aria-hidden', 'false');
                tab.classList.remove('hidden');

                if (focus) {
                    // tab.querySelectorAll('[focusable]')[0].focus();
                }
            }

            tabLinks.forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();

                    unselectLinks();
                    hideTabs();

                    selectLink(e.currentTarget);
                    showTab(tabHolder.querySelector(`[data-content-tab="${elem.getAttribute('data-show-tab')}"]`), true);
                });
            });

            hideTabs();
            selectLink(tabLinks[0]);
            showTab(tabContents[0]);
        });
    });
}
